import { AGENCY_PLATFORM_DELETE_BEGIN } from './action-types'

export const deleteAgencyPlatform = (payload, callback) => ({
  type: AGENCY_PLATFORM_DELETE_BEGIN,
  payload,
  callback,
})
